export default __webpack_public_path__ + "static/media/se-photo.a3da0336.jpeg";